import { getServerUrl } from "utils/fetch";

export function getCategories() {
  return {
    url: getServerUrl("/users/categories"),
    method: "GET",
  };
}

